import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic, faLaptopCode, faUsers } from '@fortawesome/free-solid-svg-icons';
import Button from '@mui/material/Button';
import '../assets/styles/Expertise.scss';

function Expertise() {
    return (
    <div className="container" id="portfolios">
        <div className="skills-container">
            <h1>About Me</h1>
            <p className="bio-text">
                A two-time Gonzaga graduate in Statistics and Music, I strive to build a dual-career in tech and music. From blockchain development in Rust and data analysis practices in Python to conducting church choirs and singing in semi-pro ensembles, I'm determined to continue building an interdisciplinary lifestyle medlying my two career passions.
            </p>
            <h1>Portfolios</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faMusic} size="3x"/>
                    <h3>Music</h3>
                    <p>Explore my musical compositions, projects, and choral conducting work.</p>
                    <div className="portfolio-button-container" style={{ marginTop: '20px' }}>
                        <a href="https://music.trevorbushnell.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                            <Button variant="contained" color="primary">Visit Music Portfolio</Button>
                        </a>
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faLaptopCode} size="3x"/>
                    <h3>Tech</h3>
                    <p>Discover my software engineering projects, technical stack, and development work.</p>
                    <div className="portfolio-button-container" style={{ marginTop: '20px' }}>
                        <a href="https://tech.trevorbushnell.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                            <Button variant="contained" color="primary">Visit Tech Portfolio</Button>
                        </a>
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faUsers} size="3x"/>
                    <h3>Leadership</h3>
                    <p>Learn about my leadership experience, organizational strategy, and team management.</p>
                    <div className="portfolio-button-container" style={{ marginTop: '20px' }}>
                        <a href="https://leader.trevorbushnell.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                            <Button variant="contained" color="primary">Visit Leadership Portfolio</Button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;